var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("radio-group", {
        attrs: {
          label: _vm.question.label,
          helptext: _vm.question.helpText,
          collapsibleContent: _vm.question.content,
          options: _vm.question.options,
          tooltip: _vm.question.tooltip,
          isActiveTooltip: _vm.isActiveTooltip
        },
        on: { toggleTooltip: _vm.toggleTooltip, change: _vm.emitInput }
      }),
      _vm._v(" "),
      _vm.cmsText
        ? _c("bordered-content", [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.cmsText) } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.liveChat || _vm.externalLink
        ? _c("div", [
            _vm.liveChat
              ? _c(
                  "button",
                  {
                    staticClass: "c-button c-button--brand",
                    attrs: { type: "button" }
                  },
                  [_vm._v("\n      Live Chat\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.externalLink
              ? _c(
                  "a",
                  {
                    staticClass: "c-button c-button--brand",
                    attrs: { href: _vm.externalLinkUrl }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.externalLinkText) + "\n    ")]
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fc03257", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc03257","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/_contact-us-rap/_vue/RadioGroupOptions.vue
// module id = 707
// module chunks = 0